<section class="my-6 px-4 mt-[64px]">
  <form class="flex gap-4 items-center" id="search-form">
    <figure (click)="search()" class="cursor-pointer">
      <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M27.613 25.72 23.08 21.2a10.56 10.56 0 0 0 2.253-6.533C25.333 8.776 20.558 4 14.667 4S4 8.776 4 14.667c0 5.89 4.776 10.666 10.667 10.666A10.56 10.56 0 0 0 21.2 23.08l4.52 4.533a1.333 1.333 0 0 0 1.893 0 1.333 1.333 0 0 0 0-1.893ZM6.667 14.667a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
          fill="#FFF" />
      </svg>
    </figure>

    <div class="input flex-grow">
      <input class="w-full placeholder:text-white/50 outline-none caret-accent bg-transparent" type="text" name="search"
        id="search" placeholder="Search for movies or TV series" [(ngModel)]="searchValue" (input)="search()">
    </div>
  </form>
</section>